import { useEffect, useState } from "react"
import { getAssetRegistriesForRegime } from "routes/regime/assets/controller/get-asset-registries.controller"
import { Bound } from "lib/@components/binding/Bound"
import { RegimeSelector } from "routes/regime/assets/regime-selector"
import { usePlanRoot } from "lib/use-plan-root"
import { useRefresh } from "lib/@hooks/useRefresh"
import { getIsUnlocked, setIsUnlocked } from "routes/regime/assets/controller/register-locked.controller"
import { useSave } from "lib/@hooks/use-save"
import { updateRegimeLock } from "routes/regime/assets/regime-lock-store"
import { useStoreState } from "lib/store"

export function AssetsRegimeTab() {
    const refresh = useRefresh()
    const regime = usePlanRoot()
    const parentId = regime.id
    const [target] = useState({ current: null })
    const remoteIsUnlocked = getIsUnlocked.useResults(regime.id) ?? undefined
    const registers = getAssetRegistriesForRegime.useResults(parentId) ?? []
    const regimeLockKey = `regimeLock.${parentId ?? "__none"}`
    const [lockState] = useStoreState(regimeLockKey, () => remoteIsUnlocked)
    const isUnlocked = lockState
    target.registers = registers
    useEffect(() => {
        target.isUnlocked = isUnlocked
    }, [isUnlocked, target])
    useEffect(() => {
        if (parentId && remoteIsUnlocked !== undefined) {
            updateRegimeLock(parentId, remoteIsUnlocked)
        }
    }, [parentId, remoteIsUnlocked])

    const onChange = useSave({ save: storeData, target, wait: 300 }, [parentId, isUnlocked, target])

    return (
        !!registers && (
            <Bound onChange={onChange} target={target} refresh={refresh} regime={regime}>
                <RegimeSelector />
            </Bound>
        )
    )

    async function storeData(target) {
        const tasks = []
        if (isUnlocked !== target.isUnlocked && parentId) {
            const nextUnlock = target.isUnlocked
            const previousUnlock = isUnlocked
            updateRegimeLock(parentId, nextUnlock)
            tasks.push(commitUnlockChange(parentId, nextUnlock, previousUnlock))
        }
        if (tasks.length) {
            await Promise.all(tasks)
        }
    }

    async function commitUnlockChange(regimeId, nextUnlock, previousUnlock) {
        try {
            await setIsUnlocked(regimeId, nextUnlock)
        } catch (error) {
            updateRegimeLock(regimeId, previousUnlock)
            throw error
        }
    }
}
